const constants = {
  colorRamp: {
    noDataColor: 'rgb(204, 204, 204)',
    defaultColorScheme: 'dhdsCustom',
  },
  classifiers: {
    types: [
      { description: 'Quantile', id: 'quantile' },
      { description: 'Equal Interval', id: 'equal-interval' },
      { description: 'Natural Breaks', id: 'natural-breaks' },
    ],
    classes: [4, 5, 6, 7],
  },
  labels: {
    dataUnavailable: 'Data suppressed / unavailable',
  },
};

export default constants;



// WEBPACK FOOTER //
// ./src/components/LP/Maps/constants.js